import { render, staticRenderFns } from "./IntegrationsRedirect.vue?vue&type=template&id=b5c07348"
import script from "./IntegrationsRedirect.vue?vue&type=script&lang=js"
export * from "./IntegrationsRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports